import { CheckboxFilter } from "./DispatchAvailabilityListReportResultasData";

export enum Shift {
  DAY = "1",
  NIGHT = "3",
  GRAVEYARD = "5",
  COASTWISE = "67",
  SQUAMISH = "68",
}

export const Shifts: Shift[] = [
  Shift.DAY,
  Shift.NIGHT,
  Shift.GRAVEYARD,
  Shift.COASTWISE,
  Shift.SQUAMISH
];

export enum BoardType {
  union = 'union',
  casual = 'casual'
}

export const CheckboxFilters: CheckboxFilter[] = [
  { key: 1, filter: 'usedDOAnotDispatched' },
  { key: 2, filter: 'noDOAnotDispatched' },
  { key: 3, filter: 'hasJobOnCurrentShift' },
  { key: 4, filter: 'hasJobOnPreviousShift' },
];

export const RowsPerPage = 100;